var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F7F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21C23.7614 21 26 18.7614 26 16C26 13.2386 23.7614 11 21 11C18.2386 11 16 13.2386 16 16C16 18.7614 18.2386 21 21 21Z",
    fill: "#9094A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 23.5C15.9902 23.5 11.9102 26.86 11.9102 31C11.9102 31.28 12.1302 31.5 12.4102 31.5H29.5902C29.8702 31.5 30.0902 31.28 30.0902 31C30.0902 26.86 26.0102 23.5 21.0002 23.5Z",
    fill: "#9094A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e4a9e92dcbf178f5204bb444bcbd6652.svg";
export { ForwardRef as ReactComponent };